import { $, $$ } from '@utils';
import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  if (!$('[data-au-content-block]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-content-block]').forEach((content) => {
    content.querySelectorAll('a, button').forEach((elem) => {
      const contentType = elem.nodeName === 'A' ? 'clickEnlace' : 'clickDescarga';
      const isInsideTabContent = elem.closest('[data-au-tab-content]');
      let titleText;
      let clickText = '';

      if (isInsideTabContent) {
        const tabContentId = isInsideTabContent.getAttribute('data-au-tab-content');
        const tab = document.querySelector(`[data-au-tab=${tabContentId}]`);
        tab.childNodes.forEach((value) => {
          if (value.nodeType === Node.TEXT_NODE) titleText = value.nodeValue;
        });
      } else {
        titleText = elem.closest('[data-au-content-block]').querySelector('h2')
          ? elem.closest('[data-au-content-block]').querySelector('h2').innerText
          : '';
      }
      titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;

      elem.childNodes.forEach((value) => {
        if (value.nodeType === Node.TEXT_NODE)
          clickText = value.nodeValue.length > 100 ? `${value.nodeValue.substring(0, 100)}...` : value.nodeValue;
      });
      elem.addEventListener('click', (e) => datalayerPushGeneric(e, 'navigation', contentType, titleText, clickText));
    });
  });
}

export default { init };
